import template from './underground-parking.jade';

export default angular
    .module('cian.addForm.undergroundParking', [])
    .directive('cianAfAboutBuildingUndergroundParking', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            if (!this.ad.building) {
                this.ad.building = {};
            }
            if (!this.ad.building.parking) {
                this.ad.building.parking = {};
            }
            const UNDERGROUND_OPTION = 'underground';
            // TODO move null-coalescing to utils
            this.model = this.ad.building.parking.type === UNDERGROUND_OPTION;

            this.parkingOptions = [{
                value: true,
                text: 'Есть',
            }, {
                value: false,
                text: 'Нет',
            }];

            this.onChange = () => {
                this.ad.building.parking.type = this.model ? UNDERGROUND_OPTION : undefined;
            };
        },
        controllerAs: 'undergroundParking',
        template,
    }))
    .name;
